import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, ArrowRightIcon } from 'lucide-react';
function scrollTo(href: string) {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({
    behavior: 'smooth'
  });
}
export function CompanySection() {
  return <section className="relative w-full bg-white py-16 lg:py-24" data-id="element-33">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-[2.5rem] bg-cream px-8 py-14 shadow-glass ring-1 ring-gold/10 sm:px-14 lg:px-20" data-id="element-35">
          <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-gold/10 blur-3xl" data-id="element-36" />
          <div className="relative max-w-3xl" data-id="element-37">
            <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-gold-dark shadow-sm ring-1 ring-gold/20" data-id="element-38">
              <GlobeIcon className="h-4 w-4" data-id="element-39" />
              Njega širom Evrope
            </span>
            <h2 className="font-display text-3xl font-bold leading-tight text-ink text-balance sm:text-4xl" data-id="element-40">
              Golden Care — Vaš pouzdan partner za kvalitetnu njegu širom
              Evrope.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted sm:text-lg" data-id="element-41">
              Sarađujemo s porodicama i kandidatima iz regiona i zemalja
              Evropske unije pružajući podršku tokom cijelog procesa — od prvog
              kontakta do početka angažmana.
            </p>
            <button type="button" onClick={() => scrollTo('#kontakt')} className="group mt-8 inline-flex items-center gap-2 rounded-full bg-gold-gradient px-7 py-3.5 text-sm font-semibold text-white shadow-gold transition-transform hover:scale-[1.03] active:scale-95" data-id="element-42">
              Započnite saradnju
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-43" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}